module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5fe28c3aac7eff532b531b1f40884a5b.png";